module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container section"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._l((_vm.accountStatementMatches), function(m, i) {
    return _c('div', {
      key: m.accountStatementMatch_id,
      staticClass: "row lined"
    }, [_c('div', {
      staticClass: "col-5"
    }, [_vm._v("\n      " + _vm._s(m.carrier_account_name) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-5"
    }, [_vm._v("\n      " + _vm._s(m.carrier_account_number) + "\n    ")]), _vm._v(" "), _c('div', {
      staticClass: "col-2 text-right"
    }, [_c('dropdown-confirmation', {
      attrs: {
        "name": "saveReport",
        "size": "sm",
        "direction": "right",
        "triggerBtnClass": "btn-delete",
        "triggerBtnHtml": "<i class=\"fa fa-trash\"></i>",
        "confirmBtnClass": "btn-danger",
        "confirmBtnHtml": "<i class=\"fa fa-remove\"></i>&nbsp;&nbsp;Delete"
      },
      on: {
        "confirm": function($event) {
          _vm.deleteMatch(m)
        }
      }
    })], 1)])
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row heading"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('h2', [_vm._v("Account Statement Matches")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row table-head"
  }, [_c('div', {
    staticClass: "col"
  }, [_vm._v("Carrier Account Name")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v("Carrier Account Number")]), _vm._v(" "), _c('div', {
    staticClass: "col"
  }, [_vm._v(" ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-56e28564!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/accounts/AccountStatementMatches.vue
// module id = 390
// module chunks = 0